module.exports = __webpack_public_path__ + "static/media/0010_LE_SOL_MEGALITH_MEGABLACK.e2b8094e.webp";